import { create } from "zustand";
import {
    getChapterImportJobs,
    dismissChapterImportJob,
} from "@/lib/actions/chapter-import-actions";
import type { ChapterImportJobView } from "@/lib/import/types";

// Drives the global chapter-import progress tray. The DB is the source of truth
// (jobs survive navigation/reload); this store mirrors the active rows for the
// current author and is re-fetched on a poll while any job runs.
interface ChapterImportState {
    jobs: ChapterImportJobView[];
    /** Pull the current author's active/recent import jobs from the server. */
    refresh: () => Promise<void>;
    /** Optimistically hide a finished job and persist the dismissal. */
    dismiss: (jobId: string) => Promise<void>;
}

export const useChapterImportStore = create<ChapterImportState>((set) => ({
    jobs: [],
    refresh: async () => {
        try {
            const jobs = await getChapterImportJobs();
            set({ jobs });
        } catch {
            // Not authenticated or a transient failure — keep the last snapshot.
        }
    },
    dismiss: async (jobId) => {
        set((state) => ({ jobs: state.jobs.filter((j) => j.id !== jobId) }));
        try {
            await dismissChapterImportJob(jobId);
        } catch {
            // Optimistic — the next refresh reconciles if the server disagrees.
        }
    },
}));
